import { render, staticRenderFns } from "./advertisingData.vue?vue&type=template&id=9a91027e&"
import script from "./advertisingData.vue?vue&type=script&lang=js&"
export * from "./advertisingData.vue?vue&type=script&lang=js&"
import style0 from "./advertisingData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a91027e')) {
      api.createRecord('9a91027e', component.options)
    } else {
      api.reload('9a91027e', component.options)
    }
    module.hot.accept("./advertisingData.vue?vue&type=template&id=9a91027e&", function () {
      api.rerender('9a91027e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advertisingData.vue"
export default component.exports